import { Link } from "react-router-dom";
import CommunityIcon from "../../assets/home/community.png";
import HospitalIcon from "../../assets/home/hospital.png";
import IndustryIcon from "../../assets/home/industry.png";
import styles from "./TopSubjects.module.css";

const TopSubjects = () => {
  return (
    <div>
      <div className="section">
        <div className={styles.subjectsContainer}>
          <h2>Popular Subjects</h2>
          <div className={styles.pharmacyContainer}>
            <div className={styles.pharmacyTopic}>
              <img
                src={CommunityIcon}
                alt="community pharmacy icon"
                width={50}
              />
              <p>Community Pharmacy</p>
            </div>
            <div className={styles.pharmacyTopic}>
              <img src={HospitalIcon} alt="hospital pharmacy icon" width={50} />
              <p>Hospital Pharmacy</p>
            </div>
            <div className={styles.pharmacyTopic}>
              <img src={IndustryIcon} alt="industry pharmacy icon" width={50} />
              <p>Pharmaceutical industry </p>
            </div>
          </div>
          <Link to="/courses" className="primary-btn">
            Explore All Courses
          </Link>
        </div>
      </div>
    </div>
  );
};
export default TopSubjects;
